<script lang="ts">
    import Footer from "../footer/Footer.svelte";
    import Navbar from "../header/Navbar.svelte";
    import { appManager } from "../AppManagerStore";
    import AngleLeft from "../svg/shapes/AngleLeft.svelte";
    import { _ } from "svelte-i18n";
    import Blur3 from "../svg/shapes/blurs/Blur3.svelte";
    import Curve1 from "../svg/shapes/curves/Curve1.svelte";
    import Settings1 from "../svg/icons/general/Settings1.svelte";
    import LayoutArrange from "../svg/icons/layout/LayoutArrange.svelte";
    import Code from "../svg/icons/code/Code.svelte";
    import Plans from "./Plans.svelte";
    import Testimonials from "./Testimonials.svelte";
    import FaQs from "./FAQs.svelte";
</script>

<svelte:head>
    <title>ANYWAYS | Pricing</title>
</svelte:head>

<Navbar isFluid={false} />

<Plans />

<FaQs />
  
<Testimonials /> 

<Footer bgClass="bg-gray-200" />
